// helpers.js

import dayjs from "dayjs";

export const formatCategoryName = (category) => {
    const words = category.split(/(?=[A-Z])/).map((word) => {
      return word.charAt(0).toUpperCase() + word.slice(1).toLowerCase();
    });
  
    return words.join(" ");
  };
  
  export const convertToTitleCase = (str) => {
    return str.replace(/\b\w/g, (char) => char.toUpperCase());
  };

  /**
   * Masks a Social Security Number (SSN) so that only the last four digits are visible
   * @param {string} ssn - The SSN to mask (can be with or without dashes)
   * @returns {string} - Masked SSN in format ***-**-1234
   */
  export const maskSSN = (ssn) => {
    if (!ssn) return "";
    
    // Remove any non-digit characters
    const digits = ssn.toString().replace(/\D/g, '');
    
    if (digits.length === 0) return "";
    
    if (digits.length < 4) {
      // If less than 4 digits, mask all but the last digit
      if (digits.length === 1) {
        return `***-**-***${digits}`;
      } else if (digits.length === 2) {
        return `***-**-**${digits}`;
      } else if (digits.length === 3) {
        return `***-**-*${digits}`;
      }
    }
    
    const lastFour = digits.slice(-4);
    return `***-**-${lastFour}`;
  };

  /**
   * Checks if an SSN value is already masked (contains asterisks)
   * @param {string} value - The SSN value to check
   * @returns {boolean} - True if the value is masked
   */
  export const isMaskedSSN = (value) => {
    if (!value || typeof value !== "string") return false;
    return value.includes("*");
  };

  /**
   * Extracts the last 4 digits from a masked SSN (e.g., ***-**-4234 → 4234)
   * @param {string} maskedSSN - The masked SSN string
   * @returns {string} - Last 4 digits, or empty string if not found
   */
  export const extractLastFourFromMasked = (maskedSSN) => {
    if (!maskedSSN || typeof maskedSSN !== "string") return "";
    // Extract digits from the string and get last 4
    const digits = maskedSSN.replace(/\D/g, "");
    return digits.slice(-4);
  };


  export const getYearDetailsLabel = (taxYear) => {  

     // Only format if the year is not already a 4-digit year string
     const formattedYear = String(taxYear);
     if (
       formattedYear.length !== 4 ||
       isNaN(Number(formattedYear))
     ) {
       return `${dayjs(
        taxYear
       ).format("YYYY")}`;
     } else {
       return `${formattedYear}`;
     }
  }